import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "search-input-wrapper" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'SearchInputWrapper',
    setup(__props) {
        // 검색 입력 + 버튼 래퍼 컴포넌트
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default")
            ]));
        };
    }
});
